export const MOCK_EMR_KEY = 'comprehendpt_mockEMR';

export const MOCK_EMR_PRESETS = {
  generic: {
    label: 'Generic Patient',
    patientInfo: {
      'EMR ID': 'PT-00001',
      'First Name': 'Jane',
      'Last Name': 'Smith',
      DOB: '1985-03-14',
      Metadata: '',
    },
    pageInfo: {
      URL: 'app.comprehendpt.com',
      'Note Type': 'SOAP Note',
    },
    questions: {
      questions: [],
      dropdownCache: {},
      dropdownMisses: {},
    },
  },
  webpt: {
    label: 'WebPT – Initial Eval',
    patientInfo: {
      'EMR ID': 'WPT-10293',
      'First Name': 'Robert',
      'Last Name': 'Johnson',
      DOB: '1972-08-22',
      Metadata: 'Insurance: BlueCross',
    },
    pageInfo: {
      URL: 'app.webpt.com',
      'Note Type': 'Initial Evaluation',
    },
    questions: {
      questions: [
        {
          Key: 'Chief Complaint',
          Question: 'Chief Complaint',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
        {
          Key: 'Pain Level (0-10)',
          Question: 'Pain Level (0-10)',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
        {
          Key: 'Mechanism of Injury',
          Question: 'Mechanism of Injury',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
      ],
      dropdownCache: {},
      dropdownMisses: {},
    },
  },
  webptDischargeSummary: {
    label: 'WebPT - Discharge Summary',
    patientInfo: {
      'EMR ID': 'WPT-20481',
      'First Name': 'Taylor',
      'Last Name': 'Morgan',
      DOB: '1981-04-19',
      Metadata: 'Insurance: Aetna',
    },
    pageInfo: {
      URL: 'app.webpt.com',
      'Note Type': 'Discharge Summary',
    },
    questions: {
      questions: [
        {
          Key: 'Discharge Summary',
          Question: 'Discharge Summary',
          Answer: '',
          Type: 'Flex',
          ReplyType: null,
          ExistingNote: null,
          Structure: {
            'Discharge Summary': {
              'Reason for Discharge': {
                'Existing Value': 'All Goals Met',
                Choices: [
                  'All Goals Met',
                  'Self-Discharge',
                  'No Longer Meets Medical Necessity Requirements',
                  'Treatment Plateau',
                  'Other',
                ],
              },
              'Habilitation Potential': {
                'Existing Value': 'Good',
                Choices: ['Excellent', 'Good', 'Fair', 'Poor'],
              },
              Precautions: {
                'Existing Value': 'Fall risk',
                Description:
                  "Select all applicable answers. If none apply, reply with 'None'. Provide your response as a list of choices separated by a '$' symbol.",
                Choices: [
                  'None',
                  'Fall risk',
                  'Post-surgical precautions',
                  'Weight bearing restrictions',
                  'Other',
                ],
              },
            },
          },
        },
      ],
      dropdownCache: {},
      dropdownMisses: {},
    },
  },
  athena: {
    label: 'Athena – Progress Note',
    patientInfo: {
      'EMR ID': 'ATH-55412',
      'First Name': 'Maria',
      'Last Name': 'Garcia',
      DOB: '1990-11-05',
      Metadata: 'MRN: 55412',
    },
    pageInfo: {
      URL: 'preview.athenahealth.com',
      'Note Type': 'Progress Note',
    },
    questions: {
      questions: [
        {
          Key: 'Subjective',
          Question: 'Subjective',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
        {
          Key: 'Objective',
          Question: 'Objective',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
        {
          Key: 'Assessment',
          Question: 'Assessment',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
        {
          Key: 'Plan',
          Question: 'Plan',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
      ],
      dropdownCache: {},
      dropdownMisses: {},
    },
  },
  jane: {
    label: 'Jane – Discharge Summary',
    patientInfo: {
      'EMR ID': 'JN-7821',
      'First Name': 'Chris',
      'Last Name': 'Lee',
      DOB: '1968-06-30',
      Metadata: '',
    },
    pageInfo: {
      URL: 'app.janeapp.com',
      'Note Type': 'Discharge Summary',
    },
    questions: {
      questions: [
        {
          Key: 'Goals Achieved',
          Question: 'Goals Achieved',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
        {
          Key: 'Home Exercise Program',
          Question: 'Home Exercise Program',
          Answer: '',
          Type: 'Standard',
          ReplyType: 'overwrite',
        },
      ],
      dropdownCache: {},
      dropdownMisses: {},
    },
  },
};

export function getMockEMRData() {
  try {
    const raw = sessionStorage.getItem(MOCK_EMR_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setMockEMRData(data) {
  try {
    if (data === null) {
      sessionStorage.removeItem(MOCK_EMR_KEY);
    } else {
      sessionStorage.setItem(MOCK_EMR_KEY, JSON.stringify(data));
    }
  } catch (e) {
    console.warn('Failed to write mock EMR data to sessionStorage', e);
  }
}

export function isMockEMREnabled() {
  return !!getMockEMRData()?.enabled;
}
